// extracted by mini-css-extract-plugin
module.exports = {"fullscreen":"LivePlayerScreen_fullscreen__2PXNl","error":"LivePlayerScreen_error__30XLS"};